import {AccStorage} from "./storage.interface";
import {isDefined} from "../../libs/utils/epic.utils";

/**
 * Zwischenspeicher im Arbeitsspeicher der Anwendung statt auf dem Endgerät.
 *
 * Der Zwischenspeicher legt nichts in der Endeinrichtung des Nutzers ab; § 25
 * Abs. 1 TDDDG ist damit nicht einschlägig und eine Einwilligung nicht
 * erforderlich. Preis dafür ist die Reichweite: Der Inhalt gilt für die laufende
 * Sitzung und ist nach einem Neuladen der Seite fort.
 */
export class MemoryStorage implements AccStorage {

  private readonly entries: Map<string, string> = new Map<string, string>();

  public get length(): number {
    return this.entries.size;
  }

  public clear(): void {
    this.entries.clear();
  }

  public getItem(key: string): string | null {
    const value: string | undefined = this.entries.get(key);
    return isDefined(value) ? value : null;
  }

  public key(index: number): string | null {
    const keys: string[] = Array.from(this.entries.keys());
    return index >= 0 && index < keys.length ? keys[index] : null;
  }

  public removeItem(key: string): void {
    this.entries.delete(key);
  }

  public setItem(key: string, value: string): void {
    this.entries.set(key, value);
  }
}
